import Icon from '@ant-design/icons/lib/components/Icon'
import styled from 'styled-components'
import { alertColorType } from '../../constants/alertStyleVariable'

export const AlertCollapseTitle = styled.div<{
  size?: 'small' | 'middle' | 'large'
}>`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  color: grey;
  font-size: ${(props) => (props.size === 'small' ? '0.8em' : '1.1em')};
`

export const AlertCollapseEnd = styled.span`
  font-size: 80%;
  text-align: end;
  & span {
    width: 160px;
    display: inline-block;
    text-align: end;
  }
`

export const AlertCollapseContainer = styled.div`
  height: 100%;
  width: 100%;
  margin-top: 20px;
`

export const AlertCollapseContentContainer = styled.div<{
  size?: 'small' | 'middle' | 'large'
}>`
  font-weight: 500;
  color: grey;
  font-size: ${(props) => (props.size === 'small' ? '0.7em' : '0.9em')};
`

export const alertPanelStyle = (
  type: 'Warning' | 'Critical' | 'Urgent' | 'none'
): React.CSSProperties => {
  const backgroundColor = getLightColor(alertColorType[type])
  const borderColor = alertColorType[type]

  return {
    marginBottom: 5,
    borderRadius: 5,
    marginLeft: 3,
    marginRight: 3,
    textAlign: 'left',
    background: backgroundColor,
    borderTop: `2px solid ${borderColor}`,
  }
}

export const StyledAlertIcon = styled(Icon)<{
  type: 'Warning' | 'Critical' | 'Urgent' | 'none'
  iconsize?: 'small' | 'middle' | 'large'
}>`
  color: ${(props) => alertColorType[props.type]};
  font-size: ${(props) => (props.iconsize === 'small' ? '14px' : '20px')};
  margin-right: 10px;
`

function getLightColor(color: any) {
  if (!/^#([A-Fa-f0-9]{3}){1,2}$/.test(color)) {
    throw new Error('Invalid color format. Use #RRGGBB')
  }
  let r = parseInt(color.slice(1, 3), 16)
  let g = parseInt(color.slice(3, 5), 16)
  let b = parseInt(color.slice(5, 7), 16)
  let factor = 90 / 100
  r = Math.round(r + (255 - r) * factor)
  g = Math.round(g + (255 - g) * factor)
  b = Math.round(b + (255 - b) * factor)
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`
}
